import * as React from "react";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { TradeTransitionArrow } from "../generic/common/TradeTransitionArrow";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var ResourceTradeInfo = function (props) {
    var purchasedResourceInfo = props.purchasedResourceInfo, wastedResourceInfo = props.wastedResourceInfo, backgroundStyle = props.backgroundStyle;
    return (React.createElement("div", { className: "resource-trade-info__wrapper " + backgroundStyle },
        React.createElement("div", { className: "resource-trade-info__item" },
            React.createElement(ResourceIcon, { resource: wastedResourceInfo, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
            React.createElement("div", { className: IdStyles.TextBoldPrimary },
                React.createElement(NumberFormat, { amount: wastedResourceInfo.amount }))),
        React.createElement(TradeTransitionArrow, null),
        React.createElement("div", { className: "resource-trade-info__item" },
            React.createElement(ResourceIcon, { resource: purchasedResourceInfo, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.SmallMedium }),
            React.createElement("div", { className: IdStyles.TextBoldPrimary },
                React.createElement(NumberFormat, { amount: purchasedResourceInfo.amount })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/ResourceTradeInfo.tsx
// module id = 2651
// module chunks = 3